<div class="cards-container" [ngClass]="isSummary ? 'summary' : ''">
  <mat-card class="left">
    <div class="mat-card-left-container">
      <mat-card-header *ngIf="title" class="mat-card-header">
        <mat-card-title>{{ title }}</mat-card-title>
        <mat-card-subtitle
          *ngIf="steps && currentStep >= 0"
          class="step step-mobile"
        >
          {{ "global.question" | translate }} <span>{{ currentStep }}</span> {{ "global.questionOutOf" | translate }} <span>{{ steps }}</span>
        </mat-card-subtitle>
      </mat-card-header>
      <mat-card-subtitle *ngIf="subtitle">
        <div class="subtitle-icon-container">
          <div class="icon icon-info"></div>
        </div>
        <div class="subtitle-text-container">
          {{ subtitle }}
        </div>
      </mat-card-subtitle>
      <mat-card-content>
        <ng-content select="[left-content]"></ng-content>
      </mat-card-content>
      <mat-card-actions>
        <ng-content select="[actions]"></ng-content>
      </mat-card-actions>
    </div>
  </mat-card>
  <mat-card class="right">
    <div class="mat-card-right-container">
      <mat-card-header class="mat-card-header">
        <!-- <mat-card-subtitle
          *ngIf="steps && currentStep >= 0"
          class="step step-desktop"
        >
          {{ "global.question" | translate }} <span>{{ currentStep }}</span> {{ "global.questionOutOf" | translate }} <span>{{ steps }}</span>
        </mat-card-subtitle> -->
      </mat-card-header>
      <mat-card-content>
        <ng-content select="[right-content]"></ng-content>
      </mat-card-content>
    </div>
  </mat-card>
</div>
